<template>
  <v-container fluid style="padding:0; background-color:#fafafa">
          <v-container style="padding-top:5vh;padding-bottom:5vh">
            <v-row justify="center" align="center">
              <v-col cols="10" xs="10" sm="10" md="3" lg="3" xl="3">
                <v-img src="img/logo-br.png" />
              </v-col>

              <v-col cols="10" xs="10" sm="10" md="8" lg="8" xl="8" offset="1">
                <p
                  style="line-height:1.25"
                  class="left text-h4 text-sm-h4 text-md-h4 text-lg-h5 text-xl-h3 black--text font-weight-medium"
                >
                  Stay accountable and consistent with personal help from me
                </p>

                <p
                  style="line-height:1.75"
                  class="text-h5 text-sm-h5 text-md-h5 text-lg-subtitle-1 text-xl-h6 black--text font-weight-regular"
                >
                  I live and breathe this stuff everyday, and have dedicated my
                  professional life helping people like you become fitter,
                  stronger, and healthier than ever.<br /><br />

                  Whatever obstacles arise, I’ll help you overcome them by
                  modifying your program or offering new solutions. In the end,
                  know that I’m here to support you every step of the way, no
                  matter what life throws at you.
                </p>
              </v-col>
            </v-row>
          </v-container>
  </v-container>
</template>


<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {
    //
  },
  data: () => ({
    //
  }),
  methods: {
    //
  }
};
</script>



<style>
.workSansLight{
  font-family: 'Work Sans', sans-serif !important;font-weight:400;font-style: normal;
}

.workSans{
  font-family: 'Work Sans', sans-serif !important;font-weight:700;font-style: normal;
}

.playFair{
  font-family: 'Playfair Display', serif !important;font-weight:700; font-style:italic;
}


</style>
